// Phase 6 — Track D T-D5. useDates hook.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { DateEventList } from '@dailydeck/shared/types';
import { apiClient } from '../app/apiClient.js';

export const DATES_QUERY_KEY = ['dates'] as const;

export function useDates(): UseQueryResult<DateEventList, Error> {
  return useQuery<DateEventList, Error>({
    queryKey: DATES_QUERY_KEY,
    queryFn: () => apiClient.dates.listEvents(),
  });
}
